<template>
  <!-- Activating 2FA -->
  <form v-if="isActivating2FA" class="modal-inner-container" @submit.prevent="continueActivating">
    <div class="w-full">
      <div class="text-n-4xl font-bold">
        {{$t('security.twofa.verify_authentication')}}
      </div>

      <div class="text-n-md font-medium mt-n-5xl">
        {{$t('security.twofa.enter_code')}}
      </div>
      
      <input
        @keypress="preventNonNumericalInput"
        class="v3 mt-n-4xl no-arrows"
        data-lpignore="true"
        placeholder="000000"
        data-testid="input-twofa1"
        ref="twofaRef"
        type="number"
        v-model="twofa"
      />
    </div>

    <ButtonV2
      :inactive="isLoading || !twofa"
      :label="$t('continue')"
      testId="btn-continue"
      class="mt-n-5xl"
      submit
      wide
    />
  </form>

  <!-- Deactivating 2FA -->
  <form v-else class="modal-inner-container" @submit.prevent="continueDeactivating">
    <div class="w-full">
      <div class="text-n-4xl font-bold">
        {{$t('security.twofa.disable_twofa')}}
      </div>

      <div class="text-n-md font-medium mt-n-5xl">
        {{$t('security.twofa.enter_code')}}
      </div>
      
      <input
        @keypress="preventNonNumericalInput"
        class="v3 mt-n-4xl no-arrows"
        data-lpignore="true"
        placeholder="000000"
        data-testid="input-twofa"
        ref="twofaRef"
        type="number"
        v-model="twofa"
      />

      <div class="warning-container">
        {{$t('security.twofa.warning')}}
      </div>
    </div>

    <ButtonV2
      :inactive="isLoading || !twofa"
      :label="$t('continue')"
      class="mt-n-5xl"
      submit
      wide
    />
  </form>
</template>

<script>
  import TWO_FACTOR_AUTH_SETUP_STEP_THREE from '@/graphql/mutations/TwoFactorAuthSetupStepThree.gql';
  import TWO_FACTOR_AUTH_DISABLE_STEP_ONE from '@/graphql/mutations/TwoFactorAuthDisableStepOne.gql';
  import ButtonV2 from '@/stories/misc/ButtonV2';

  export default {
    name: 'VerifyAuthentication',
    components: {
      ButtonV2,
    },

    data() {
      return {
        twofa: '',
        isLoading: false,
        isActivating2FA: !this.lodashGet(this.$store.state.api, 'current_user.user_info.twofa_enabled', false),
      };
    },

    watch: {
      twofa(newValue, oldValue) {
        if (newValue.length > 6) {
          this.twofa = oldValue;
        }
      },
    },

    async mounted() {
      this.$refs.twofaRef.focus();
      if (this.isActivating2FA) {
        await this.$store.dispatch('events/track', {
          event: 'TWO_FACTOR_ENABLE_VERIFY_CODE_VIEWED',
        });
        return;
      }
      await this.$store.dispatch('events/track', {
        event: 'TWO_FACTOR_DISABLE_VERIFY_CODE_VIEWED',
      });
    },

    methods: {
      async continueActivating() {
        try {
          this.isLoading = true;

          await this.apolloApiCall({
            mutation: TWO_FACTOR_AUTH_SETUP_STEP_THREE,
            variables: {
              twofa: this.twofa,
            }
          });

          const currentUser = { ...this.$store.state.api.current_user };

          this.$store.commit('api/setState', { stateName: 'current_user', stateData: { ...currentUser, user_info: { ...currentUser.user_info, twofa_enabled: true, } } });

          return this.showModal('TwoFactorAuthenticationEnabled');
        } catch (err) {
          await this.showError(err);
        } finally {
          this.isLoading = false;
        }
      },

      async continueDeactivating() {
        try {
          this.isLoading = true;

          await this.apolloApiCall({
            mutation: TWO_FACTOR_AUTH_DISABLE_STEP_ONE,
            variables: {
              twofa: this.twofa,
            }
          });

          this.showModal('DisableTwoFactorAuthentication');
        } catch (err) {
          await this.showError(err);
        } finally {
          this.isLoading = false;
        }
      },
    },
  };
</script>
